import { useState, useEffect, useContext } from "react";
import { NAME_SERVER } from "../../../Utils/NAME_HOST";
import styles from "./Dropdown_methods.module.css";
import UserService from "../../../service/UserService";
import { observer } from "mobx-react-lite";
import { Context } from "../../..";
import { pack } from "../../../Utils/forSocket";

function Dropdown_methods({ state, setState,items,setValueId,setValueName}) {
    const {store} = useContext(Context);
    console.log(items,"items")
    
    
    
    const [avatar, setAvatar] = useState(null);
    const [color, setColor] = useState(null);

    const colors_data = [
        "rgba(46, 177, 139, 0.63)",
        "rgb(113 46 177 / 63%)",
        "rgb(46 67 177 / 63%)",
        "rgb(168 178 34 / 63%)",
        "rgb(178 73 34 / 63%)",
        "rgb(255 255 255 / 63%)",
        "rgb(0 0 0 / 63%)"
    ];
    async function save(){
        const response = await UserService.changeAvatar(avatar,color);
        
        if (response.data.status === 1){
            store.socket.send(pack({ event: "change_avatar", data: {login:store.user.login,avatar,color} }));

            window.location.reload();
        }
    }

    useEffect(() => {
        
        if (avatar && color) {
            save();
            
        }
        if (!state){
            setAvatar(null)
            setColor(null)
        }
    }, [avatar, color, setState,state]);


    if (state) {
        return (
            <div className={styles.dropdown}>
                <div className="dropdown-items">
                    
                    {items.map((value,index)=>
                        <div
                        key={index}
                        className="item text-option"
                        onClick={()=>{setValueId(value.value);setValueName(value.label);setState(false)}}
                        
                    >
                        {value.label}
                    </div>
                    )}
                </div>
                <div className="blank" onClick={() => setState(false)} />
            </div>
        );
    }

    return null; // Добавьте return null, чтобы ничего не рендерить, когда state === false
}

export default observer(Dropdown_methods);
